const FJMathUtil = {
    /**
     * @desc 取得小数位精度的值
     * @param value
     * @param digits - 小数后第几位
     * @return {number}
     */
    floor: function (value, digits = 1) {
        let d = Math.pow(10, digits);
        if (value >= 0) return Math.floor(value * d) / d;
        else return -Math.floor(-value * d) / d;
    },

    even: function (num) {
        return Math.floor(num) % 2 === 0 ? Math.floor(num) : Math.floor(num) - 1;
    },
    /**
     * @desc 按比例缩放尺寸，使最长边不超过 maxLongEdge；原最长边已不大于 maxLongEdge 时不放大。
     * @param {number} width
     * @param {number} height
     * @param {number} maxLongEdge
     * @returns {{ width: number, height: number }}
     */
    scaleToMaxLongEdge: function (width, height, maxLongEdge) {
        const iw = width > 0 ? width : 1;
        const ih = height > 0 ? height : 1;
        const longEdge = Math.max(iw, ih);
        const scale = longEdge > maxLongEdge ? maxLongEdge / longEdge : 1;
        return {
            width: Math.max(1, Math.round(iw * scale)),
            height: Math.max(1, Math.round(ih * scale)),
        };
    },
    /**
     * @desc 判断线段是否与rect有交集
     * @param lp1
     * @param lp2
     * @param rect
     * @return {boolean}
     */
    intersectsLineWithRect: function (lp1, lp2, rect) {
        let p1 = { x: rect.x, y: rect.y },
            p2 = { x: rect.x + rect.width, y: rect.y },
            p3 = { x: rect.x + rect.width, y: rect.y + rect.height },
            p4 = { x: rect.x, y: rect.y + rect.height };

        let __lineIntersectionWithLine = (l1p1, l1p2, l2p1, l2p2) => {
            let Ax = l1p1.x;
            let Ay = l1p1.y;
            let Bx = l1p2.x;
            let By = l1p2.y;
            let Cx = l2p1.x;
            let Cy = l2p1.y;
            let Dx = l2p2.x;
            let Dy = l2p2.y;

            let distAB, theCos, theSin, newX, ABpos;

            //  Fail if either line is undefined.
            if ((Ax === Bx && Ay === By) || (Cx === Dx && Cy === Dy)) return false;

            //  (1) Translate the system so that point A is on the origin.
            Bx -= Ax;
            By -= Ay;
            Cx -= Ax;
            Cy -= Ay;
            Dx -= Ax;
            Dy -= Ay;

            //  Discover the length of segment A-B.
            distAB = Math.sqrt(Bx * Bx + By * By);

            //  (2) Rotate the system so that point B is on the positive X axis.
            theCos = Bx / distAB;
            theSin = By / distAB;
            newX = Cx * theCos + Cy * theSin;
            Cy = Cy * theCos - Cx * theSin;
            Cx = newX;
            newX = Dx * theCos + Dy * theSin;
            Dy = Dy * theCos - Dx * theSin;
            Dx = newX;

            if ((Cy < 0 && Dy < 0) || (Cy > 0 && Dy > 0)) return false;

            //  (3) Discover the position of the intersection point along line A-B.
            ABpos = Dx + ((Cx - Dx) * Dy) / (Dy - Cy);

            //  Fail if segment C-D crosses line A-B outside of segment A-B.
            if (ABpos < 0 || ABpos > distAB) return false;

            //  Success.
            return true;
        };
        let result = false;
        result |= __lineIntersectionWithLine(lp1, lp2, p1, p2);
        result |= __lineIntersectionWithLine(lp1, lp2, p2, p3);
        result |= __lineIntersectionWithLine(lp1, lp2, p3, p4);
        result |= __lineIntersectionWithLine(lp1, lp2, p4, p1);
        return result;
    },
    /**
     * @desc 判断点是否在某个范围内
     * @param point {object} {x, y}
     * @param rect {object} {x, y, width, height}
     * @return {boolean}
     */
    isPointInRect: function (point, rect, isEqual = true) {
        if (!point || !rect) return false;
        if (isEqual) {
            return (
                point.x >= rect.x &&
                point.x <= rect.x + rect.width &&
                point.y >= rect.y &&
                point.y <= rect.y + rect.height
            );
        } else {
            return (
                point.x > rect.x && point.x < rect.x + rect.width && point.y > rect.y && point.y < rect.y + rect.height
            );
        }
    },
    fitSize: function (outerSize, innerSize, float = false) {
        let r1 = innerSize.width / innerSize.height;
        let r2 = outerSize.width / outerSize.height;
        let w, h;
        if (r1 >= r2) {
            w = outerSize.width;
            h = w / r1;
        } else {
            h = outerSize.height;
            w = h * r1;
        }
        if (float) {
            return { width: w, height: h };
        } else {
            return { width: Math.floor(w), height: Math.floor(h) };
        }
    },
    fillSize: function (outerSize, innerSize, float = false) {
        let r1 = innerSize.width / innerSize.height;
        let r2 = outerSize.width / outerSize.height;
        let w, h;
        if (r1 >= r2) {
            h = outerSize.height;
            w = h * r1;
        } else {
            w = outerSize.width;
            h = w / r1;
        }
        if (float) {
            return { width: w, height: h };
        } else {
            return { width: Math.floor(w), height: Math.floor(h) };
        }
    },
    adaptSizeWithMaxSize: function (size, maxSize) {
        let w = size.width,
            h = size.height;
        if (size.width > maxSize || size.height > maxSize) {
            let r = size.width / size.height;
            if (r >= 1) {
                w = maxSize;
                h = w / r;
            } else {
                h = maxSize;
                w = h * r;
            }
        }

        return { width: Math.ceil(w), height: Math.ceil(h) };
    },
    adaptSizeWithMinSize: function (size, minSize) {
        let w = size.width,
            h = size.height;
        let r = w / h;
        if (r >= 1) {
            h = minSize;
            w = h * r;
        } else {
            w = minSize;
            h = w / r;
        }
        return { width: Math.ceil(w), height: Math.ceil(h) };
    },
    // 保留2位小数
    toFixed: function (value, fractionDigits = 2) {
        if (!value) return 0;
        return Number(value.toFixed(fractionDigits));
    },
    /**
     * @description 字节 -> mb
     * @param {value} byte
     * @returns
     */
    byte2Megabyte: function (byte) {
        return byte / (1000 * 1000);
    },
    evenSize: function (size) {
        size.width = Math.floor(size.width);
        size.height = Math.floor(size.height);

        if (size.width % 2 !== 0) size.width--;
        if (size.height % 2 !== 0) size.height--;

        return size;
    },
    integratedRect: function (rect) {
        let integrationRect = {};
        let right = Math.round(rect.x + rect.width);
        let top = Math.round(rect.y + rect.height);
        integrationRect.x = Math.floor(rect.x);
        integrationRect.y = Math.floor(rect.y);
        integrationRect.width = right - integrationRect.x;
        integrationRect.height = top - integrationRect.y;
        return integrationRect;
    },
    fixSizeWithMinHeight: function (size, minSize) {
        let r = size.width / size.height;
        let w, h;
        h = minSize;
        w = h * r;
        return { width: Math.ceil(w), height: Math.ceil(h) };
    },
    fixSizeWithMinWidth: function (size, minSize) {
        let r = size.width / size.height;
        let w, h;
        w = minSize;
        h = w / r;
        return { width: Math.ceil(w), height: Math.ceil(h) };
    },
    // 得到rect1在rect2里的中心的坐标
    getCenterPoint: function (rect1, rect2) {
        let point = {};
        if (rect1.width <= rect2.width) point.x = rect1.width / 2;
        else point.x = -rect1.x + rect2.width / 2;

        if (rect1.height <= rect2.height) point.y = rect1.height / 2;
        else point.y = -rect1.y + rect2.height / 2;

        return point;
    },
    getLeftPoint: function (rect1, rect2) {
        let point = {};
        if (rect1.width <= rect2.width) point.x = 0;
        else point.x = -rect1.x;

        if (rect1.height <= rect2.height) point.y = rect1.height / 2;
        else point.y = -rect1.y + rect2.height / 2;

        return point;
    },
    getRightPoint: function (rect1, rect2) {
        let point = {};
        if (rect1.width <= rect2.width) point.x = rect1.width;
        else point.x = rect1.width - rect1.x;

        if (rect1.height <= rect2.height) point.y = rect1.height / 2;
        else point.y = -rect1.y + rect2.height / 2;

        return point;
    },
    getTopPoint: function (rect1, rect2) {
        let point = {};
        if (rect1.width <= rect2.width) point.x = rect1.width / 2;
        else point.x = -rect1.x + rect2.width / 2;

        if (rect1.height <= rect2.height) point.y = 0;
        else point.y = -rect1.y;

        return point;
    },
    getBottomPoint: function (rect1, rect2) {
        let point = {};
        if (rect1.width <= rect2.width) point.x = rect1.width / 2;
        else point.x = -rect1.x + rect2.width / 2;

        if (rect1.height <= rect2.height) point.y = rect1.height;
        else point.y = rect1.height - rect1.y;

        return point;
    },

    /**
     * 计算旋转后的矩形的中心点坐标
     * @param {Object} rotatedPoint - 旋转后的角点坐标 {x: number, y: number}
     * @param {string} corner - 角的位置 ('left-top' | 'right-top' | 'left-bottom' | 'right-bottom' | 'top' | 'bottom' | 'left' | 'right' | 'center')
     * @param {number} width - 矩形宽度
     * @param {number} height - 矩形高度
     * @param {number} angle - 旋转角度（度数）
     * @returns {Object} 矩形的中心点坐标 {x: number, y: number}
     */
    convertCenterPointToOriginal: function (rotatedPoint, corner, width, height, angle) {
        // 将角度转换为弧度
        const radians = (angle * Math.PI) / 180;

        // 计算未旋转时该点相对于中心点的偏移量
        let offsetX, offsetY;

        switch (corner) {
            case 'left-top':
                offsetX = -width / 2;
                offsetY = -height / 2;
                break;
            case 'right-top':
                offsetX = width / 2;
                offsetY = -height / 2;
                break;
            case 'left-bottom':
                offsetX = -width / 2;
                offsetY = height / 2;
                break;
            case 'right-bottom':
                offsetX = width / 2;
                offsetY = height / 2;
                break;
            case 'top':
                offsetX = 0;
                offsetY = -height / 2;
                break;
            case 'bottom':
                offsetX = 0;
                offsetY = height / 2;
                break;
            case 'left':
                offsetX = -width / 2;
                offsetY = 0;
                break;
            case 'right':
                offsetX = width / 2;
                offsetY = 0;
                break;
            case 'center':
                offsetX = 0;
                offsetY = 0;
                break;
            default:
                throw new Error('Invalid corner position');
        }

        // 计算偏移量旋转后的位置
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);

        const rotatedOffsetX = offsetX * cos - offsetY * sin;
        const rotatedOffsetY = offsetX * sin + offsetY * cos;

        // 用旋转后的点坐标减去旋转后的偏移量，得到中心点坐标
        return {
            x: rotatedPoint.x - rotatedOffsetX,
            y: rotatedPoint.y - rotatedOffsetY,
        };
    },

    /**
     * @desc 转换点在旋转后的坐标
     * @param point - 坐标点
     * @param centerPoint - 中心点
     * @param angle - 旋转角度，为负则顺时针，反之为逆时针
     * @return {{x: *, y: *}}
     */
    convertPointByAngle: function (point, centerPoint, angle) {
        let l = (angle * Math.PI) / 180,
            cosv = Math.cos(l),
            sinv = -Math.sin(l);
        let x = (point.x - centerPoint.x) * cosv - (point.y - centerPoint.y) * sinv + centerPoint.x,
            y = (point.x - centerPoint.x) * sinv + (point.y - centerPoint.y) * cosv + centerPoint.y;
        return { x: x, y: y };
    },
    getRectAfterTransformation: function (rect, angle) {
        if (!rect) return null;

        if (angle === 0) return rect;

        let centerPoint = { x: rect.x + rect.width / 2, y: rect.y + rect.height / 2 };
        let left_top = { x: rect.x, y: rect.y },
            right_top = { x: rect.x + rect.width, y: rect.y },
            left_bottom = { x: rect.x, y: rect.y + rect.height },
            right_bottom = { x: rect.x + rect.width, y: rect.y + rect.height };
        let n_left_top = FJMathUtil.convertPointByAngle(left_top, centerPoint, angle),
            n_right_top = FJMathUtil.convertPointByAngle(right_top, centerPoint, angle),
            n_left_bottom = FJMathUtil.convertPointByAngle(left_bottom, centerPoint, angle),
            n_right_bottom = FJMathUtil.convertPointByAngle(right_bottom, centerPoint, angle);

        let x = Math.min(n_left_top.x, n_right_top.x, n_left_bottom.x, n_right_bottom.x),
            y = Math.min(n_left_top.y, n_right_top.y, n_left_bottom.y, n_right_bottom.y),
            right = Math.max(n_left_top.x, n_right_top.x, n_left_bottom.x, n_right_bottom.x),
            bottom = Math.max(n_left_top.y, n_right_top.y, n_left_bottom.y, n_right_bottom.y);

        return { x: x, y: y, width: right - x, height: bottom - y };
    },
    /**
     * @desc 进行move时吸附的操作，通过比较当前元素的rect和其他对象和page的rect，求出最小的x,y的偏移值
     * @param originalRect - 当前元素的rect
     * @param viewSize - 当前画布的size
     * @param otherRects - 其他元素对象的rect
     * @param angle - 元素的旋转角度
     * @param adsorptionOffset - 有效吸附距离
     * @return {{}} - 返回吸附后的对象的rect
     */
    adsorption: function (originalRect, viewSize, otherRects, angle = 0, adsorptionOffset = 6) {
        let rect = { ...originalRect };
        // 横向的page的吸附线的吸附点
        let horizontalAdsorptions = [
            0,
            viewSize.height * 0.1,
            viewSize.height / 2,
            viewSize.height * 0.9,
            viewSize.height,
        ];
        // 竖向的page的吸附线的吸附点
        let verticalAdsorptions = [0, viewSize.width * 0.1, viewSize.width / 2, viewSize.width * 0.9, viewSize.width];
        if (angle !== 0) {
            originalRect = FJMathUtil.getRectAfterTransformation(originalRect, angle);
        }

        // 自身对象的横向吸附线的吸附点
        let horizontalSelfValues = [
            originalRect.y,
            originalRect.y + originalRect.height / 2,
            originalRect.y + originalRect.height,
        ];
        // 自身对象的竖向吸附线的吸附点
        let verticalSelfValues = [
            originalRect.x,
            originalRect.x + originalRect.width / 2,
            originalRect.x + originalRect.width,
        ];
        let horizontalAdsorptionSuccess = false;
        let verticalAdsorptionSuccess = false;

        let minX = adsorptionOffset; // 最小的横向吸附需要的x的偏移
        let minY = adsorptionOffset; // 最小的竖向吸附需要的y的偏移
        if (otherRects) {
            // 遍历自身的吸附点和其他元素的rect进行比较，更新最小的x,y的偏移值
            otherRects.forEach(eleRect => {
                if (eleRect) {
                    let horizontal = [eleRect.y, eleRect.y + eleRect.height / 2, eleRect.y + eleRect.height];
                    let vertical = [eleRect.x, eleRect.x + eleRect.width / 2, eleRect.x + eleRect.width];
                    horizontal.forEach(y => {
                        horizontalSelfValues.forEach(sy => {
                            if (Math.abs(y - sy) <= Math.abs(minY)) minY = y - sy;
                        });
                    });

                    vertical.forEach(x => {
                        verticalSelfValues.forEach(sx => {
                            if (Math.abs(x - sx) <= Math.abs(minX)) minX = x - sx;
                        });
                    });
                }
            });
        }

        // 和page的吸附点比较，更新最小的x,y的偏移值
        for (let i = 0; i < horizontalAdsorptions.length; i++) {
            for (let j = 0; j < horizontalSelfValues.length; j++) {
                if (Math.abs(horizontalAdsorptions[i] - horizontalSelfValues[j]) <= Math.abs(minY)) {
                    minY = horizontalAdsorptions[i] - horizontalSelfValues[j];
                    horizontalAdsorptionSuccess = true;
                    break;
                }
            }
            if (horizontalAdsorptionSuccess) {
                break;
            }
        }
        for (let i = 0; i < verticalAdsorptions.length; i++) {
            for (let j = 0; j < verticalSelfValues.length; j++) {
                if (Math.abs(verticalAdsorptions[i] - verticalSelfValues[j]) <= Math.abs(minX)) {
                    minX = verticalAdsorptions[i] - verticalSelfValues[j];
                    verticalAdsorptionSuccess = true;
                    break;
                }
            }
            if (verticalAdsorptionSuccess) {
                break;
            }
        }

        if (Math.abs(minY) < adsorptionOffset) rect.y += minY;
        if (Math.abs(minX) < adsorptionOffset) rect.x += minX;
        return rect;
    },
    getValueInRange: function (value, min, max) {
        value = value < min ? min : value;
        value = value > max ? max : value;
        return value;
    },
    contentSizeByOrientation: function (size, rotation) {
        let outputSize = { ...size };
        switch (rotation) {
            case 90:
            case 270:
                outputSize.width = size.height;
                outputSize.height = size.width;
                break;
            default:
                break;
        }
        return outputSize;
    },
    changeOrientation: function (ctx, originalSize, rotation, flipX, flipY) {
        switch (rotation) {
            case 0:
                break;
            case 90:
                ctx.transform(0, 1, -1, 0, originalSize.height, 0);
                break;
            case 180:
                ctx.transform(-1, 0, 0, -1, originalSize.width, originalSize.height);
                break;
            case 270:
                ctx.transform(0, -1, 1, 0, 0, originalSize.width);
                break;
            default:
                return;
        }

        if (flipX === -1) {
            ctx.transform(-1, 0, 0, 1, originalSize.width, 0);
        }
        if (flipY === -1) {
            ctx.transform(1, 0, 0, -1, 0, originalSize.height);
        }
    },
    compareValue(value, min, max, decimal = 1) {
        const compareValue = FJMathUtil.toFixed(value, decimal);
        const compareMin = FJMathUtil.toFixed(min, decimal);
        const compareMax = FJMathUtil.toFixed(max, decimal);
        if (compareValue >= compareMin && compareValue <= compareMax) {
            return true;
        } else {
            return false;
        }
    },
    checkFloatEqual: function (v1, v2) {
        return Math.abs(v1 - v2) < 0.0001;
    },

    angleAtPoint: function (currentPoint, centerPoint) {
        let dx = currentPoint.x - centerPoint.x;
        let dy = currentPoint.y - centerPoint.y;

        if (dy === 0.0) {
            if (dx > 0) return Math.PI / 2;
            else return (3 * Math.PI) / 2;
        }

        let tan = dx / dy;
        let angle = Math.atan(tan);

        if (dy < 0) angle += Math.PI;
        else if (dx < 0 && dy > 0) angle += 2 * Math.PI;

        if (Math.abs(angle) <= 0) angle = 0;
        else if (Math.abs(angle - Math.PI / 2) <= 0) angle = Math.PI / 2;
        else if (Math.abs(angle - Math.PI) <= 0) angle = Math.PI;
        else if (Math.abs(angle - (3 * Math.PI) / 2) <= 0) angle = (3 * Math.PI) / 2;
        else if (Math.abs(angle - Math.PI * 2) <= 0) angle = 0;

        return angle;
    },
    /**
     * @desc 得到一个rect通过一个point进行angle的旋转后的新的rect
     * @param rect
     * @param centerPoint - 旋转的点
     * @param angle - 旋转角度
     * @return {*}
     */
    getRectByAngleFromPoint: function (rect, centerPoint, angle) {
        if (angle === 0) return rect;
        // element对象中心点
        let elementCenter = { x: rect.x + rect.width / 2, y: rect.y + rect.height / 2 };
        // 对象中心点相对打组对象中心点的坐标
        let relativeCenterPoint = {
            x: elementCenter.x - centerPoint.x,
            y: elementCenter.y - centerPoint.y,
        };

        // 求得相对中心点到0，0点的半径
        let radius = Math.sqrt(Math.pow(relativeCenterPoint.x, 2) + Math.pow(relativeCenterPoint.y, 2));
        // 第2个参数的点是相对4象限的，所以y轴要翻转下
        let relativeAngle = FJMathUtil.angleAtPoint(
            { x: 0, y: 0 },
            {
                x: relativeCenterPoint.x,
                y: -relativeCenterPoint.y,
            },
        );
        relativeAngle = (relativeAngle * 180) / Math.PI;
        let point = FJMathUtil.getPointWidthAngle(centerPoint, radius, relativeAngle + angle + 90);
        point.x -= rect.width / 2;
        point.y -= rect.height / 2;
        rect.x = point.x;
        rect.y = point.y;
        return rect;
    },
    /**
     * @desc 根据圆心和半径，角度，计算出在这个圆上的点的坐标
     * @param centerPoint 圆心坐标
     * @param r 半径
     * @param angle 角度
     * @returns {{x: *, y: *}} 在圆上的坐标
     * @private
     */
    getPointWidthAngle(centerPoint, r, angle) {
        let x = centerPoint.x + r * Math.cos((angle * Math.PI) / 180);
        let y = centerPoint.y + r * Math.sin((angle * Math.PI) / 180);
        return { x: x, y: y };
    },

    /**
     * @description 时长差值小等于 0.001 就算相等
     * @param value1
     * @param value2
     * @return {boolean}
     */
    isValueEqual: function (value1, value2, offset = 0.001, digits = 4) {
        return FJMathUtil.toFixed(Math.abs(value1 - value2), digits) <= FJMathUtil.toFixed(offset, digits);
    },
    /**
     * @description 返回rect中某个点的坐标
     * @param {string} position
     * @param {object} rect
     * @param {number} angle
     */
    calcPointInRect: function (position, rect, angle = 0) {
        let { x, y, width, height } = rect;
        let centerPoint = {
            x: x + width / 2,
            y: y + height / 2,
        };
        let coor = {
            x: 0,
            y: 0,
        };
        switch (position) {
            case 'leftTop':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: -width / 2,
                        y: height / 2,
                    },
                    angle,
                );
                break;
            case 'leftCenter':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: -width / 2,
                        y: 0,
                    },
                    angle,
                );
                break;
            case 'leftBottom':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: -width / 2,
                        y: -height / 2,
                    },
                    angle,
                );
                break;
            case 'centerTop':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: 0,
                        y: height / 2,
                    },
                    angle,
                );
                break;
            case 'centerBottom':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: 0,
                        y: -height / 2,
                    },
                    angle,
                );
                break;
            case 'rightTop':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: width / 2,
                        y: height / 2,
                    },
                    angle,
                );
                break;
            case 'rightCenter':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: width / 2,
                        y: 0,
                    },
                    angle,
                );
                break;
            case 'rightBottom':
                coor = FJMathUtil.calcPointAfterRotate(
                    {
                        x: width / 2,
                        y: -height / 2,
                    },
                    angle,
                );
                break;
            default:
        }

        return {
            x: centerPoint.x + coor.x,
            y: centerPoint.y - coor.y,
        };
    },
    /**
     * @description 计算坐标系旋转后点相对于原来坐标系的坐标
     * @param {*} point
     * @param {*} angle
     */
    calcPointAfterRotate: function (point, angle = 0) {
        let { cos, sin } = Math;
        let radian = FJMathUtil.angle2radian(-angle);
        let x = point.x * cos(radian) - point.y * sin(radian);
        let y = point.x * sin(radian) + point.y * cos(radian);
        return {
            x,
            y,
        };
    },
    /**
     * @description 角度转弧度
     * @param {number} angle
     */
    angle2radian(angle) {
        return (angle / 180) * Math.PI;
    },
    /**
     * @description 弧度转角度
     * @param {number} radian
     */
    radian2angle(radian) {
        return (radian / Math.PI) * 180;
    },

    fixAngle(angle) {
        let value = angle;
        while (value < 0 || value > 360) {
            if (value < 0) value += 360;
            if (value >= 360) value -= 360;
        }
        return value;
    },

    /**
     * @description 计算旋转后的由四个边界点连接成的新的rect
     * @param rect
     * @param rotation
     * @return {{x: number, width: number, y: number, height: number}}
     */
    calcRectWithRotation: function (rect, rotation) {
        let point1 = FJMathUtil.calcPointInRect('leftTop', rect, rotation);
        let point2 = FJMathUtil.calcPointInRect('rightTop', rect, rotation);
        let point3 = FJMathUtil.calcPointInRect('rightBottom', rect, rotation);
        let point4 = FJMathUtil.calcPointInRect('leftBottom', rect, rotation);
        let minHorizontal = Math.min(point1.x, point2.x, point3.x, point4.x);
        let maxHorizontal = Math.max(point1.x, point2.x, point3.x, point4.x);
        let minVertical = Math.min(point1.y, point2.y, point3.y, point4.y);
        let maxVertical = Math.max(point1.y, point2.y, point3.y, point4.y);
        return {
            x: minHorizontal,
            y: minVertical,
            width: maxHorizontal - minHorizontal,
            height: maxVertical - minVertical,
        };
    },

    /**
     * @descritpion 相对位置尺寸转换为实际位置尺寸
     */
    relativeRectToRect: function (relativeRect, viewSize) {
        const { width, height } = viewSize;
        return {
            x: relativeRect.x * width,
            y: relativeRect.y * height,
            width: relativeRect.width * width,
            height: relativeRect.height * height,
        };
    },
    /**
     * @descritpion 实际位置尺寸转换为相对位置尺寸
     */
    rectToRelativeRect: function (rect, viewSize) {
        const { width, height } = viewSize;
        return {
            x: rect.x / width,
            y: rect.y / height,
            width: rect.width / width,
            height: rect.height / height,
        };
    },
    /**
     * @desc 已知4个点组成的2条线段，获取相交点 线段1（a, b），线段2 (c, d)
     * @param a
     * @param b
     * @param c
     * @param d
     * @return {boolean|{x: number, y: number}}
     */
    getCrossPoint: (a, b, c, d) => {
        /** 1 解线性方程组, 求线段交点. **/
        // 如果分母为0 则平行或共线, 不相交
        let denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y);
        if (denominator === 0) {
            return false;
        }

        // 线段所在直线的交点坐标 (x , y)
        let x =
            ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) +
                (b.y - a.y) * (d.x - c.x) * a.x -
                (d.y - c.y) * (b.x - a.x) * c.x) /
            denominator;
        let y =
            -(
                (b.y - a.y) * (d.y - c.y) * (c.x - a.x) +
                (b.x - a.x) * (d.y - c.y) * a.y -
                (d.x - c.x) * (b.y - a.y) * c.y
            ) / denominator;

        /** 2 判断交点是否在两条线段上 **/
        if (
            // 交点在线段1上
            (x - a.x) * (x - b.x) <= 0.0001 &&
            (y - a.y) * (y - b.y) <= 0.0001 &&
            // 且交点也在线段2上
            (x - c.x) * (x - d.x) <= 0.0001 &&
            (y - c.y) * (y - d.y) <= 0.0001
        ) {
            // 返回交点p
            return {
                x: x,
                y: y,
            };
        }
        //否则不相交
        return false;
    },
    /**
     * 精度处理
     * @param {*} number
     * @return {Number}
     */
    handleNumberPrecision(number) {
        const diff = 10000000;
        return Math.round(number * diff) / diff;
    },
    /**
     * @desc 求起点绕中心点旋转到终点的最小弧度，该弧度一定小于PI，而不是一定以顺时针或逆时针的弧度
     * @param centerPoint
     * @param startPoint
     * @param endPoint
     * @return {number}
     */
    getRadianAt3Point: (centerPoint, startPoint, endPoint) => {
        const ac = { x: startPoint.x - centerPoint.x, y: startPoint.y - centerPoint.y };
        const bc = { x: endPoint.x - centerPoint.x, y: endPoint.y - centerPoint.y };
        const dotProduct = ac.x * bc.x + ac.y * bc.y;
        const abDistance = Math.sqrt(Math.pow(ac.x, 2) + Math.pow(ac.y, 2));
        const bcDistance = Math.sqrt(Math.pow(bc.x, 2) + Math.pow(bc.y, 2));
        // 等于0则表示有可能在同一条线段上
        if (abDistance === 0 || bcDistance === 0) return Math.PI;
        return Math.acos(dotProduct / (abDistance * bcDistance));
    },
    /**
     * @desc 从一个点沿另一个点移动distance距离，求得该点的坐标
     * @param fromPoint
     * @param toPoint
     * @param distance
     * @return {{x: *, y: *}}
     */
    getPointFrom2PointMoveDistance: (fromPoint, toPoint, distance) => {
        const dx = toPoint.x - fromPoint.x;
        const dy = toPoint.y - fromPoint.y;
        const length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
        const unit_dx = dx / length,
            unit_dy = dy / length;
        const x = fromPoint.x + distance * unit_dx,
            y = fromPoint.y + distance * unit_dy;
        return { x, y };
    },

    /**
     * @desc 求一个大矩形内部的一个小矩形刚好离开大矩形四个边上的距离 ** 1. 位置坐标基于一个坐标系
     * @param {{x,y,width,height}} bigRect 大矩形的 rect
     * @param {{x,y,width,height}} rect 小矩形的 rect   旋转前的位置坐标
     * @param {number} angle 旋转角度
     */
    getLeaveBigRectDistance: (bigRect, rect, angle = 0) => {
        // 第一步 转换坐标系， 以小矩形的左上顶点为原点， 上边为x轴，下边为y轴 建立坐标系
        // 求大矩形相对于新坐标系的顶点坐标
        const newBigRect = {
            leftUp: { x: bigRect.x - rect.x, y: bigRect.y - rect.y },
            rightUp: { x: bigRect.x + bigRect.width - rect.x, y: bigRect.y - rect.y },
            leftDown: { x: bigRect.x - rect.x, y: bigRect.y + bigRect.height - rect.y },
            rightDown: { x: bigRect.x + bigRect.width - rect.x, y: bigRect.y + bigRect.height - rect.y },
        };

        // 新坐标系下的小矩形坐标
        const newRectPoint = {
            leftUp: { x: 0, y: 0 },
            rightUp: { x: rect.width, y: 0 },
            leftDown: { x: 0, y: rect.height },
            rightDown: { x: rect.width, y: rect.height },
        };

        // 将大矩形按小矩形中心点旋转
        // 大矩形旋转中心点
        const rectCenterPoint = {
            x: (newRectPoint.leftUp.x + newRectPoint.rightUp.x) / 2,
            y: (newRectPoint.leftUp.y + newRectPoint.leftDown.y) / 2,
        };

        // 旋转大矩形， 并获取旋转后的大矩形4个点的坐标
        const bigAngle = angle;
        newBigRect.leftUp = FJMathUtil.convertPointByAngle(newBigRect.leftUp, rectCenterPoint, bigAngle);
        newBigRect.rightUp = FJMathUtil.convertPointByAngle(newBigRect.rightUp, rectCenterPoint, bigAngle);
        newBigRect.leftDown = FJMathUtil.convertPointByAngle(newBigRect.leftDown, rectCenterPoint, bigAngle);
        newBigRect.rightDown = FJMathUtil.convertPointByAngle(newBigRect.rightDown, rectCenterPoint, bigAngle);

        let leaveDistance = {
            topList: [],
            bottomList: [],
            leftList: [],
            rightList: [],
        };

        // 判断矩形的4个顶点是否满足某一方向上的离开点条件，如果满足则放回顶点列表
        const __getMaxDistanceRectPeakPoints = hasX => {
            let peakPoints = [];

            const ___judgeMaxDistanceHasBigRectPeakPoint = (hasX, point) => {
                if (hasX) {
                    return point.x >= newRectPoint.leftUp.x && point.x <= newRectPoint.rightUp.x;
                } else {
                    return point.y <= newRectPoint.leftDown.y && point.y >= newRectPoint.leftUp.y;
                }
            };

            Object.values(newBigRect).forEach(item => {
                if (___judgeMaxDistanceHasBigRectPeakPoint(hasX, item)) {
                    peakPoints.push(item);
                }
            });

            return peakPoints;
        };

        // 获取满足 上/下 离开点的顶点
        const maxDistanceRectPeakPointsX = __getMaxDistanceRectPeakPoints(true);

        // 通过顶点中上下可能的离开点记录离开点的离开距离
        if (maxDistanceRectPeakPointsX.length > 0) {
            maxDistanceRectPeakPointsX.forEach(peatPoint => {
                if (peatPoint === null) return;

                if (peatPoint.y >= newRectPoint.leftUp.y) {
                    leaveDistance.bottomList.push(peatPoint.y);
                }

                if (peatPoint.y <= newRectPoint.leftDown.y) {
                    leaveDistance.topList.push(-peatPoint.y + rect.height);
                }
            });
        }
        // 获取小矩形左右俩条边与大矩形4条边的交点  该交点为小矩形上下方向离开大矩形可能的离开点
        const leftIntersectPoint = FJMathUtil.getRectIntersectPointsOfX(newBigRect, newRectPoint.leftUp.x);
        const rightIntersectPoint = FJMathUtil.getRectIntersectPointsOfX(newBigRect, newRectPoint.rightUp.x);

        // 通过交点获取可能的上下离开距离
        const __getUpOrDownLeaveDistanceOfIntersectPoint = objPoint => {
            Object.values(objPoint).forEach(item => {
                if (item === null) return;

                if (item.y >= newRectPoint.leftUp.y) {
                    leaveDistance.bottomList.push(item.y);
                }

                if (item.y <= newRectPoint.leftDown.y) {
                    leaveDistance.topList.push(-item.y + rect.height);
                }
            });
        };

        __getUpOrDownLeaveDistanceOfIntersectPoint(leftIntersectPoint);
        __getUpOrDownLeaveDistanceOfIntersectPoint(rightIntersectPoint);

        // 获取满足 左/右 离开点的顶点
        const maxDistanceRectPeakPointsY = __getMaxDistanceRectPeakPoints(false);

        // 通过顶点中左右可能的离开点记录离开点的离开距离
        if (maxDistanceRectPeakPointsY.length > 0) {
            maxDistanceRectPeakPointsY.forEach(peatPoint => {
                if (peatPoint === null) return;

                if (peatPoint.x >= newRectPoint.leftUp.x) {
                    leaveDistance.rightList.push(peatPoint.x);
                }

                if (peatPoint.x <= newRectPoint.rightUp.x) {
                    leaveDistance.leftList.push(-peatPoint.x + rect.width);
                }
            });
        }

        // 获取小矩形上下俩条边与大矩形4条边的交点  该交点为小矩形左右方向离开大矩形可能的离开点
        const upIntersectPoint = FJMathUtil.getRectIntersectPointsOfY(newBigRect, newRectPoint.leftUp.y);
        const downIntersectPoint = FJMathUtil.getRectIntersectPointsOfY(newBigRect, newRectPoint.leftDown.y);

        // 通过交点获取可能的左/右离开距离
        const __getLeftOrRightLeaveDistanceOfIntersectPoint = objPoint => {
            Object.values(objPoint).forEach(item => {
                if (item === null) return;

                if (item.x >= newRectPoint.leftUp.x) {
                    leaveDistance.rightList.push(item.x);
                }

                if (item.x <= newRectPoint.rightUp.x) {
                    leaveDistance.leftList.push(-item.x + rect.width);
                }
            });
        };
        __getLeftOrRightLeaveDistanceOfIntersectPoint(upIntersectPoint);
        __getLeftOrRightLeaveDistanceOfIntersectPoint(downIntersectPoint);

        // 整理 leaveDistance 按从大到小排序
        let { topList, bottomList, leftList, rightList } = leaveDistance;

        topList.sort((a, b) => b - a);
        bottomList.sort((a, b) => b - a);
        leftList.sort((a, b) => b - a);
        rightList.sort((a, b) => b - a);

        return {
            top: topList[0] || 0,
            bottom: bottomList[0] || 0,
            left: leftList[0] || 0,
            right: rightList[0] || 0,
        };
    },

    /**
     * @desc 判断同一坐标系下某一个点是否在 已知的点一、点二通过 x / y 轴平行线隔成区间范围内
     * @param {{x, y}} point1   坐标系下的点一
     * @param {{x, y}} point2    坐标系下的点二
     * @param {{x, y}} point    坐标系下的判断点，只需要知道 x | y 的一个值，不需要都知道
     */
    judgePointHasInTwoPointBetween: (point1, point2, point) => {
        const { x, y } = point;
        if (x !== undefined) {
            const minX = point1.x > point2.x ? point2.x : point1.x;
            const maxX = point1.x > point2.x ? point1.x : point2.x;

            return point.x >= minX && point.x <= maxX;
        }

        if (y !== undefined) {
            const minY = point1.y > point2.y ? point2.y : point1.y;
            const maxY = point1.y > point2.y ? point1.y : point2.y;

            return point.y >= minY && point.y <= maxY;
        }

        return false;
    },

    /**
     * @desc 已知矩形4个顶点在一个坐标系下的坐标，求已知 y 与矩形4条边的交点，没有交点以及超出矩形范围的交点返回为 null
     * @param {{leftUp:{x,y}, rightUp:{x,y}, leftDown:{x,y}, rightDown:{x,y},}} rectPoint
     * @param {number} x
     */
    getRectIntersectPointsOfY: (rectPeakPoint, y) => {
        const { leftUp, rightUp, leftDown, rightDown } = rectPeakPoint;

        const __getIntersectPoint = (peakPoint1, peakPoint2, y) => {
            // 判断交点是否在矩形的边框上
            const hasInLineSegment = FJMathUtil.judgePointHasInTwoPointBetween(peakPoint1, peakPoint2, { y });
            if (hasInLineSegment) {
                return { x: FJMathUtil.getYInLineOfY(peakPoint1, peakPoint2, y), y: y };
            } else {
                // 不在矩形边框内则返回 null
                return null;
            }
        };

        const lineUpPoint = __getIntersectPoint(leftUp, rightUp, y);
        const lineRightPoint = __getIntersectPoint(rightUp, rightDown, y);
        const lineDownPoint = __getIntersectPoint(leftDown, rightDown, y);
        const lineLeftPoint = __getIntersectPoint(leftUp, leftDown, y);

        return {
            lineUpPoint,
            lineRightPoint,
            lineDownPoint,
            lineLeftPoint,
        };
    },

    /**
     * @desc 已知矩形4个顶点在一个坐标系下的坐标，求已知 x 与矩形4条边的交点，没有交点以及超出矩形范围的交点返回为 null
     * @param {{leftUp:{x,y}, rightUp:{x,y}, leftDown:{x,y}, rightDown:{x,y},}} rectPoint
     * @param {number} x
     */
    getRectIntersectPointsOfX: (rectPeakPoint, x) => {
        const { leftUp, rightUp, leftDown, rightDown } = rectPeakPoint;

        const __getIntersectPoint = (peakPoint1, peakPoint2, x) => {
            // 判断交点是否在矩形的边框上
            const hasInLineSegment = FJMathUtil.judgePointHasInTwoPointBetween(peakPoint1, peakPoint2, { x });
            if (hasInLineSegment) {
                return { x: x, y: FJMathUtil.getYInLineOfX(peakPoint1, peakPoint2, x) };
            } else {
                // 不在矩形边框内则返回 null
                return null;
            }
        };

        const lineUpPoint = __getIntersectPoint(leftUp, rightUp, x);
        const lineRightPoint = __getIntersectPoint(rightUp, rightDown, x);
        const lineDownPoint = __getIntersectPoint(leftDown, rightDown, x);
        const lineLeftPoint = __getIntersectPoint(leftUp, leftDown, x);

        return {
            lineUpPoint,
            lineRightPoint,
            lineDownPoint,
            lineLeftPoint,
        };
    },

    /**
     * @desc 通过俩个点求已知y 在该俩点连成的线段上的 x 值
     * @param {{x,y}} point
     * @param {{x,y}} pointTwo
     * @param {number} y
     * @return number | null
     */
    getYInLineOfY: (point, pointTwo, y) => {
        const { x: x1, y: y1 } = point;
        const { x: x2, y: y2 } = pointTwo;

        // 如果所给的俩个点x值相等则 x
        if (Math.abs(x2 - x1) < 0.1) return x1;
        const k = (y2 - y1) / (x2 - x1);

        let x = (y - y1) / k + x1;
        return x;
    },

    /**
     * @desc 通过俩个点求已知x 在该俩点连成的线段上的 y 值
     * @param {{x,y}} point
     * @param {{x,y}} pointTwo
     * @param {number} x
     * @return number | null
     */
    getYInLineOfX: (point, pointTwo, x) => {
        const { x: x1, y: y1 } = point;
        const { x: x2, y: y2 } = pointTwo;

        // 如果所给的俩个点x值相等则返回异常
        if (Math.abs(x2 - x1) < 0.1) return null;
        const k = (y2 - y1) / (x2 - x1);
        let y = k * (x - x1) + y1;
        return y;
    },

    /**
     * @desc 三阶贝塞尔曲线 y 值计算
     * @param {number} x 占据总曲线的x值比例
     * @param {{x,y}} p1 起点坐标
     * @param {{x,y}} p2 终点坐标
     * @param {{x,y}} cp1 控制点1
     * @param {{x,y}} cp2 控制点2
     */
    threeBezierY: (x, p1, cp1, cp2, p2) => {
        const { y: y1 } = p1;
        const { y: y2 } = p2;
        const { y: cy1 } = cp1;
        const { y: cy2 } = cp2;

        let y =
            y1 * (1 - x) * (1 - x) * (1 - x) +
            3 * cy1 * x * (1 - x) * (1 - x) +
            3 * cy2 * x * x * (1 - x) +
            y2 * x * x * x;
        return y;
    },

    /**
     * CSS cubic-bezier(x1,y1,x2,y2)：线性时间进度 t∈[0,1] 映射为贝塞尔变速后的 y∈[0,1]
     * 曲线端点固定为 (0,0)→(1,1)，(x1,y1)、(x2,y2) 为两控制点；x1、x2 宜在 [0,1] 以保证 x 随参数单调
     * @param {number} t
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @returns {number}
     */
    cubicBezierEase: function (t, x1, y1, x2, y2) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        const bx = u =>
            3 * x1 * u * (1 - u) * (1 - u) + 3 * x2 * u * u * (1 - u) + u * u * u;
        const by = u =>
            3 * y1 * u * (1 - u) * (1 - u) + 3 * y2 * u * u * (1 - u) + u * u * u;
        let lo = 0;
        let hi = 1;
        for (let i = 0; i < 28; i++) {
            const mid = (lo + hi) * 0.5;
            if (bx(mid) < t) lo = mid;
            else hi = mid;
        }
        const u = (lo + hi) * 0.5;
        return by(u);
    },

    /**
     * @description 返回一个中间值
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number}
     */
    valueOfInterval(value, min, max) {
        let result = 0;
        result = value < min ? min : value;
        result = result > max ? max : result;
        return result;
    },

    /**
     * @description 计算两点之间的差值
     * @param {Object} oldPoint
     * @param {number} oldPoint.x
     * @param {number} oldPoint.y
     * @param {Object} newPoint
     * @param {number} newPoint.x
     * @param {number} newPoint.y
     * @return {{x: number, y: number}}
     */
    calcPointOffset(oldPoint, newPoint) {
        return {
            x: newPoint.x - oldPoint.x,
            y: newPoint.y - oldPoint.y,
        };
    },

    /**
     * 随机数种子生成器
     *
     * @param {string} factor
     * @returns
     */
    generateSeedRandom: function (factor) {
        let seed = 0;

        for (let i = 0; i < factor.length; i++) {
            const char = factor.charCodeAt(i);
            seed = (seed << 5) - seed + char;
            seed |= 0;
        }

        const a = 16807;
        const m = 2147483647;
        seed = seed % m;
        if (seed < 0) seed += m;
        return function () {
            seed = (seed * a) % m;
            return seed / m;
        };
    },

    /**
     * @description 数组乱序
     * @param {*} arr
     * @param {*} factor
     * @returns
     */
    shuffleArray: function (arr, factor) {
        const rng = this.generateSeedRandom(factor.toString());
        const array = [...arr];

        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(rng() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }

        return array;
    },

    /**
     * @description 计算两点之间的直线距离
     * @param point1
     * @param point2
     * @returns {number}
     */
    calculateDistance: function (point1, point2, scaleRatio = 1) {
        const dx = (point2.x - point1.x) * scaleRatio;
        const dy = (point2.y - point1.y) * scaleRatio;
        return Math.sqrt(dx * dx + dy * dy);
    },

    calculateAngle: function (point1, point2, scaleRatio = 1) {
        const dx = (point2.x - point1.x) * scaleRatio;
        const dy = (point2.y - point1.y) * scaleRatio;
        const radians = Math.atan2(dy, dx);
        return radians * (180 / Math.PI);
    },

    /**
     * @description 大小转化 文件大小转换/单位换算
     * @param size 文件大小（转换，必填）
     * @param pointLength 转换完，保留几位小数（选填，默认保存2位）
     * @param units 指定单位类型（选填）
     * @returns {string}
     */
    formatSize: function (size, pointLength, units) {
        let unit;
        units = units || ['B', 'KB', 'MB', 'GB', 'TB'];
        while ((unit = units.shift()) && Math.round(size) >= 1024) {
            size /= 1024;
        }
        return (unit === 'B' ? size : size.toFixed(pointLength === undefined ? 2 : pointLength)) + unit;
    },

    /**
     * 将十六进制颜色转换为RGBA对象
     * @param {string} hex - 十六进制颜色值，支持 '#RGB'、'#RGBA'、'#RRGGBB'、'#RRGGBBAA' 格式
     * @returns {Object} RGBA颜色对象 {r, g, b, a}
     */
    hexToRGBA: function (hex) {
        // 移除 # 前缀
        hex = hex.replace(/^#/, '');

        // 处理不同长度的十六进制值
        let r,
            g,
            b,
            a = 1;
        if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16) / 255;
            g = parseInt(hex[1] + hex[1], 16) / 255;
            b = parseInt(hex[2] + hex[2], 16) / 255;
        } else if (hex.length === 4) {
            r = parseInt(hex[0] + hex[0], 16) / 255;
            g = parseInt(hex[1] + hex[1], 16) / 255;
            b = parseInt(hex[2] + hex[2], 16) / 255;
            a = parseInt(hex[3] + hex[3], 16) / 255;
        } else if (hex.length === 6) {
            r = parseInt(hex.substring(0, 2), 16) / 255;
            g = parseInt(hex.substring(2, 4), 16) / 255;
            b = parseInt(hex.substring(4, 6), 16) / 255;
        } else if (hex.length === 8) {
            r = parseInt(hex.substring(0, 2), 16) / 255;
            g = parseInt(hex.substring(2, 4), 16) / 255;
            b = parseInt(hex.substring(4, 6), 16) / 255;
            a = parseInt(hex.substring(6, 8), 16) / 255;
        } else {
            throw new Error('Invalid hex color format');
        }

        return { r, g, b, a };
    },

    matchCropRect: function (direction, options) {
        const { viewSize, relativeRect, groupRelativeRect, resourceSize, elementAngle, frameMaskData } = options;
        const renderRect = {
            x: relativeRect.x * (groupRelativeRect?.width || 1) * viewSize.width,
            y: relativeRect.y * (groupRelativeRect?.height || 1) * viewSize.height,
            width: relativeRect.width * (groupRelativeRect?.width || 1) * viewSize.width,
            height: relativeRect.height * (groupRelativeRect?.height || 1) * viewSize.height,
        };

        if (frameMaskData?.info?.size && frameMaskData?.info?.maskRect) {
            const { size, maskRect } = frameMaskData.info;
            const xOffset = (maskRect.x / size.width) * renderRect.width;
            const yOffset = (maskRect.y / size.height) * renderRect.height;
            const wOffset = (maskRect.width / size.width) * renderRect.width;
            const hOffset = (maskRect.height / size.height) * renderRect.height;
            renderRect.x += xOffset;
            renderRect.y += yOffset;
            renderRect.width = wOffset;
            renderRect.height = hOffset;
        }

        const newRenderRect = this.fitSize(renderRect, resourceSize, true);
        const { width, height } = newRenderRect;
        const angle = -elementAngle;

        const centerPoint = { x: renderRect.x + renderRect.width / 2, y: renderRect.y + renderRect.height / 2 };
        const leftTopPoint = { x: renderRect.x, y: renderRect.y };
        const rightTopPoint = { x: renderRect.x + renderRect.width, y: renderRect.y };
        const leftBottomPoint = { x: renderRect.x, y: renderRect.y + renderRect.height };
        const rightBottomPoint = { x: renderRect.x + renderRect.width, y: renderRect.y + renderRect.height };
        const leftPoint = { x: renderRect.x, y: centerPoint.y };
        const rightPoint = { x: renderRect.x + renderRect.width, y: centerPoint.y };
        const topPoint = { x: centerPoint.x, y: renderRect.y };
        const bottomPoint = { x: centerPoint.x, y: renderRect.y + renderRect.height };

        const leftTopPointWithAngle = FJMathUtil.convertPointByAngle(leftTopPoint, centerPoint, angle);
        const rightTopPointWithAngle = FJMathUtil.convertPointByAngle(rightTopPoint, centerPoint, angle);
        const leftBottomPointWithAngle = FJMathUtil.convertPointByAngle(leftBottomPoint, centerPoint, angle);
        const rightBottomPointWithAngle = FJMathUtil.convertPointByAngle(rightBottomPoint, centerPoint, angle);
        const centerPointWithAngle = FJMathUtil.convertPointByAngle(centerPoint, centerPoint, angle);
        const leftPointWithAngle = FJMathUtil.convertPointByAngle(leftPoint, centerPoint, angle);
        const rightPointWithAngle = FJMathUtil.convertPointByAngle(rightPoint, centerPoint, angle);
        const topPointWithAngle = FJMathUtil.convertPointByAngle(topPoint, centerPoint, angle);
        const bottomPointWithAngle = FJMathUtil.convertPointByAngle(bottomPoint, centerPoint, angle);

        let centerX = centerPoint.x;
        let centerY = centerPoint.y;

        switch (direction) {
            case 'left-top': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    leftTopPointWithAngle,
                    'left-top',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'right-top': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    rightTopPointWithAngle,
                    'right-top',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'left-bottom': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    leftBottomPointWithAngle,
                    'left-bottom',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'right-bottom': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    rightBottomPointWithAngle,
                    'right-bottom',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'top': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    topPointWithAngle,
                    'top',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'bottom': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    bottomPointWithAngle,
                    'bottom',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'left': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    leftPointWithAngle,
                    'left',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            case 'right': {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    rightPointWithAngle,
                    'right',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
            default: {
                const { x, y } = FJMathUtil.convertCenterPointToOriginal(
                    centerPointWithAngle,
                    'center',
                    width,
                    height,
                    -angle,
                );
                centerX = x;
                centerY = y;
                break;
            }
        }

        newRenderRect.x = centerX - width / 2;
        newRenderRect.y = centerY - height / 2;

        return {
            x: newRenderRect.x / ((groupRelativeRect?.width || 1) * viewSize.width),
            y: newRenderRect.y / ((groupRelativeRect?.height || 1) * viewSize.height),
            width: newRenderRect.width / ((groupRelativeRect?.width || 1) * viewSize.width),
            height: newRenderRect.height / ((groupRelativeRect?.height || 1) * viewSize.height),
        };
    },

    /**
     * @desc 组合两个围绕不同中心点的旋转，返回一次等效旋转（角度与旋转中心）
     * @param {{x:number,y:number,width:number,height:number}} renderRect - 参考坐标系矩形
     * @param {{x:number,y:number}} childCenter - 子元素中心（绝对坐标）
     * @param {number} childAngleDeg - 子元素角度（度）
     * @param {{x:number,y:number}} parentCenter - 父元素中心（绝对坐标）
     * @param {number} parentAngleDeg - 父元素角度（度）
     * @returns {{angleDeg:number, originX:number, originY:number}} - 等效角度与相对 renderRect 的旋转中心
     */
    composeRotationsDifferentOrigins(renderRect, childCenter, childAngleDeg, parentCenter, parentAngleDeg) {
        const cX = childCenter.x - renderRect.x;
        const cY = childCenter.y - renderRect.y;
        const gX = parentCenter.x - renderRect.x;
        const gY = parentCenter.y - renderRect.y;

        const a = ((childAngleDeg || 0) * Math.PI) / 180;
        const b = ((parentAngleDeg || 0) * Math.PI) / 180;
        const totalDeg = (childAngleDeg || 0) + (parentAngleDeg || 0);

        const cosT = Math.cos(a + b);
        const sinT = Math.sin(a + b);

        const oneMinusCosT = 1 - cosT;
        const det = 2 * oneMinusCosT;

        const cosB = Math.cos(b),
            sinB = Math.sin(b);
        const cosA = Math.cos(a),
            sinA = Math.sin(a);

        // (I - R_b) * G
        const v1x = (1 - cosB) * gX + sinB * gY;
        const v1y = -sinB * gX + (1 - cosB) * gY;
        // (I - R_a) * C
        const v2x = (1 - cosA) * cX + sinA * cY;
        const v2y = -sinA * cX + (1 - cosA) * cY;
        // R_b * v2
        const rv2x = cosB * v2x - sinB * v2y;
        const rv2y = sinB * v2x + cosB * v2y;
        // v 向量
        const vx = v1x + rv2x;
        const vy = v1y + rv2y;

        let oX = cX,
            oY = cY;
        if (Math.abs(det) > 1e-8) {
            // (I - R_total)^{-1} = (1/det) * [[1-cosT, -sinT], [sinT, 1-cosT]]
            oX = (oneMinusCosT * vx - sinT * vy) / det;
            oY = (sinT * vx + oneMinusCosT * vy) / det;
        } else {
            // 退化情形：总角度≈0 或≈360°，采用父中心
            oX = gX;
            oY = gY;
        }

        return { angleDeg: totalDeg, originX: oX, originY: oY };
    },
};

export default FJMathUtil;
